import { useMutation, useQueryClient } from '@tanstack/react-query';

import { sentryCaptureMessage } from '@/components/Sentry';

import { DASHBOARD_RECENTLY_VIEWED_QUERY_KEY } from '@/components/Dashboard/components/RecentlyViewed/hooks/useRecentlyViewedCompanies';

import mutationFn from './mutationFn';

export default function useSubmitCompanyViewed() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn,
    retry: 1,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DASHBOARD_RECENTLY_VIEWED_QUERY_KEY],
      });
    },
    onError: (error: Error) => {
      sentryCaptureMessage({
        team: 'wombats',
        message: 'Company Viewed event submission failed',
        extra: {
          data: error?.message,
        },
      });
    },
  });

  return mutation;
}
